// client/src/views/Interactive_parts/poiCreationHandlers.js
export function createPoiCreationHandlers({
  fileInputRef,
  poiImageInputRef,
  setIconFile,
  setIconPreview,
  setPoiImageFile,
  setPoiImagePreview,
  setForceHideCreate,
  setPendingPOI,
  savePOI
}) {
  function resetCreateFormFiles() {
    if (fileInputRef.current) fileInputRef.current.value = '';
    if (poiImageInputRef.current) poiImageInputRef.current.value = '';
    setIconFile(null);
    setIconPreview(null);
    setPoiImageFile(null);
    setPoiImagePreview(null);
  }

  function closeCreateModal() {
    resetCreateFormFiles();
    setForceHideCreate(true);
    if (typeof setPendingPOI === 'function') {
      setPendingPOI(null);
    }
  }

  // MapView.savePOI expects the 4th arg to be an "extra" object.
  // This handler now accepts either:
  //   - an extra object (e.g. { overlay_id, visual_style, ... })
  //   - a raw overlay id (number/string), for backward compatibility
  async function savePOIAndClose(name, imgUrl, desc, extraOrOverlayId = null) {
    try {
      let extra = {};

      if (
        extraOrOverlayId !== null &&
        extraOrOverlayId !== undefined &&
        typeof extraOrOverlayId === 'object' &&
        !Array.isArray(extraOrOverlayId)
      ) {
        extra = extraOrOverlayId;
      } else if (extraOrOverlayId !== null && extraOrOverlayId !== undefined && extraOrOverlayId !== '') {
        extra = { overlay_id: extraOrOverlayId };
      }

      await savePOI(name, imgUrl, desc, extra);
    } finally {
      closeCreateModal();
    }
  }

  return {
    closeCreateModal,
    savePOIAndClose
  };
}
